var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bg-top"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"tit"},[_c('strong',[_vm._v("INCELLDERM")]),_vm._v(" PRODUCTS ")]),_c('p',{staticClass:"desc mt-2"},[_vm._v("우수한 피부 과학과 "),_c('span',{staticClass:"mbr"}),_vm._v("자연 유래 성분의 만남으로 "),_c('span',{staticClass:"mbr"}),_c('span',{staticClass:"brs"}),_vm._v("스킨케어 제품의 새로운 시대를 열다")])])])
}]

export { render, staticRenderFns }